import { useNavigate } from "react-router-dom";
import { useForgotPassword } from "../../hooks/useForgotPassword";
import EmailStep from "./EmailStep";
import PasswordStep from "./PasswordStep";
import SuccessStep from "./SuccessStep";
import TokenStep from "./TokenStep";

const UserForgotPasswordFlow = () => {
  const navigate = useNavigate();

  const {
    currentStep,
    email,
    token,
    newPassword,
    confirmPassword,
    error,
    isLoading,
    setEmail,
    setToken,
    setCurrentStep,
    setNewPassword,
    setConfirmPassword,
    handleEmailSubmit,
    handleTokenSubmit,
    handlePasswordSubmit,
  } = useForgotPassword();

  const renderCurrentStep = () => {
    switch (currentStep) {
      case "email":
        return (
          <EmailStep
            email={email}
            setEmail={setEmail}
            isLoading={isLoading}
            onSubmit={handleEmailSubmit}
            onCancel={() => navigate("/login")}
          />
        );
      case "token":
        return (
          <TokenStep
            email={email}
            token={token}
            setToken={setToken}
            isLoading={isLoading}
            onSubmit={handleTokenSubmit}
            onBack={() => setCurrentStep("email")}
          />
        );
      case "password":
        return (
          <PasswordStep
            newPassword={newPassword}
            confirmPassword={confirmPassword}
            setNewPassword={setNewPassword}
            setConfirmPassword={setConfirmPassword}
            isLoading={isLoading}
            onSubmit={handlePasswordSubmit}
            onBack={() => setCurrentStep("token")}
          />
        );
      case "success":
        return <SuccessStep />;
      default:
        return null;
    }
  };

  return (
    <div className="w-full max-w-md bg-white p-10 rounded-xl shadow-lg">
      {error && (
        <div className="mb-4 p-4 text-red-700 bg-red-100 rounded-lg">
          {error}
        </div>
      )}
      
      {renderCurrentStep()}
    </div>
  );
};

export default UserForgotPasswordFlow;
